import api from './api';

export const getPropertyTypesApi = (params) => api().get('/options-property-types', { params });
export const addNewPropertyTypeApi = (data) => api().post('/options-property-types', data);
export const deletePropertyTypesApi = (params) => api().delete('/options-property-types', { params });
export const updatePropertyTypesApi = (params) => api().put(`/options-property-types/${params.id}`, params.values);
